<template>
  <div class="top-operation__container top-left-shadow">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style scoped>
.top-operation__container {
  padding: 20px;
  position: relative;
  background-color: #fff;
  height: 70px;
  /* overflow-y: hidden; */
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
}
</style>



// WEBPACK FOOTER //
// src/components/top-operation-box/index.vue